import React, { useContext } from "react"
import { LoadingContext } from "./loading.context"
import { API_BASE_URL } from "./services.config"

const mainApiUrl = API_BASE_URL.main
export const DefaultURl = mainApiUrl.endsWith('/') ? mainApiUrl : mainApiUrl + '/'

export function DefaultFunctionURL() {
    const ctx = useContext(LoadingContext)
    return ctx.DEFAULTURL ? ctx.DEFAULTURL : DefaultURl
}

// SERVIDOR DEVLOP
//export const DefaultURl = 'http://192.168.20.5:5101/api/v1/'
// SERVIDOR DEV WEBTRANS 
//export const DefaultURl = 'http://dev.webtrans.devlop.systems/backend/api/v1/'
//export const DefaultURl = 'http://dev.nexus.webtrans.devlop.systems/backend/api/v1/'
// LOCALHOST
// export const DefaultURl = 'https://localhost:44375/api/v1/'
// SERVIDOR PRODUÇÃO NAIP
//export const DefaultURl = 'http://psl.webtrans.devlop.systems:6817/api/v1/'
//export const DefaultURl = 'http://psl.dev.webtrans.devlop.systems:6817/api/v1/'
//export const DefaultURl = 'http://localhost:6917/api/v1/'